import { render } from "./sidebarInvoiceNew.vue?vue&type=template&id=1c73bf8c&scoped=true"
import script from "./sidebarInvoiceNew.vue?vue&type=script&lang=js"
export * from "./sidebarInvoiceNew.vue?vue&type=script&lang=js"

import "./sidebarInvoiceNew.vue?vue&type=style&index=0&id=1c73bf8c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c73bf8c"]])

export default __exports__